module.exports = __webpack_public_path__ + "img/icon 4@3x.a8375372.png";